import type { BoxListItem, BoxProductItem } from "../../../api/WarehouseApi";
import type { DestroyConfirmTarget } from "./destroy-confirm";
import { resolveDestroyConfirmPlan } from "./destroy-flow";

export async function performDestroyByConfirmOperation(input: {
  target: DestroyConfirmTarget | null;
  childBoxes: BoxListItem[];
  childProducts: BoxProductItem[];
  deleteCurrentBox: (deleteReason?: string | null) => Promise<void>;
  deleteChildBox: (
    item: BoxListItem,
    deleteReason?: string | null,
  ) => Promise<void>;
  deleteProductFromBox: (
    item: BoxProductItem,
    deleteReason?: string | null,
  ) => Promise<void>;
  setActionError: (message: string | null) => void;
  clearTarget: () => void;
  deleteReason?: string | null;
}): Promise<void> {
  const plan = resolveDestroyConfirmPlan({
    target: input.target,
    childBoxes: input.childBoxes,
    childProducts: input.childProducts,
  });
  if (plan.kind === "none") {
    return;
  }

  if (plan.kind === "unavailable") {
    input.setActionError(plan.message);
    input.clearTarget();
    return;
  }

  if (plan.kind === "currentBox") {
    await input.deleteCurrentBox(input.deleteReason);
    input.clearTarget();
    return;
  }

  if (plan.kind === "childBox") {
    await input.deleteChildBox(plan.item, input.deleteReason);
    input.clearTarget();
    return;
  }

  await input.deleteProductFromBox(plan.item, input.deleteReason);
  input.clearTarget();
}
